import React, { useEffect, useState } from "react";
import { getCartItems, getCartInfo, order, queue } from "../../../service/cartService";
import { toast } from "react-toastify";
import { navigate } from "gatsby";
import { isAuth } from "../../../helpers/general";

const ComplateOrderMobile = () => {
    if (isAuth === false) {
        window.location.href = '/';
    }
    const [msg, setMsg] = useState('Đơn hàng của ba/mẹ đang được tiếp tục xử lý, vui lòng chờ trong giây lát!');
    const [orderInfo, setOrderInfo] = useState([]);
    const [id, setId] = useState('');
    const [orderSuccess, setOrderSuccess] = useState(true);
    try {
        order(null, window.localStorage.getItem('key')).then((response) => {
            if (response.status === 201) {
                queue(response['message']._id, window.localStorage.getItem('key')).then((response1) => {
                    console.log(response1.status);
                    if (response1.status === 200) {
                        setOrderInfo(response1['message']);
                        setId(response1['message']._id);
                        localStorage.removeItem("itemsCart");
                        setMsg('Đơn được xử lý thành công.');
                        setOrderSuccess(true);
                        return;
                    }
                    if (response1['message'].status_queue === 2) {
                        if (response1['message'].validate_result?.status === 400) {
                            setMsg('Đơn hàng của ba/mẹ đang được tiếp tục xử lý, vui lòng chờ trong giây lát!')
                        } else {
                            setMsg(response1['message'].validate_result?.message);
                        }
                        toast.error('Đặt hàng không thành công. Vui lòng thử lại!');
                        window.location.reload();
                        // setTimeout(function () {
                        //     window.location.reload();
                        // }, 1000);
                        return;
                    } else {
                        if (response1.status !== 200) {
                            for (var i = 1; i <= 50; i++) {
                                setTimeout(() => {
                                    queue(response['message']._id, window.localStorage.getItem('key')).then((response2) => {
                                        if (response2['message'].status_queue === 2) {
                                            if (response2['message'].validate_result?.status === 400) {
                                                setMsg('Đơn hàng của ba/mẹ đang được tiếp tục xử lý, vui lòng chờ trong giây lát!');
                                            } else {
                                                setMsg(response2['message'].validate_result?.message);
                                            }
                                            toast.error('Đặt hàng không thành công. Vui lòng thử lại!');
                                            window.location.reload();
                                            return;
                                        }
                                        if (response2.status === 200) {
                                            setOrderInfo(response2['message']);
                                            setId(response2['message']._id);
                                            localStorage.removeItem("itemsCart");
                                            setMsg('Đơn được xử lý thành công.');
                                            setOrderSuccess(true);
                                            return;
                                        }

                                    });
                                    setMsg('Đơn hàng của ba/mẹ đang được tiếp tục xử lý, vui lòng chờ trong giây lát!');
                                }, 100);
                            }
                        } else {
                            console.log(response1);
                            setMsg('Có lỗi xảy ra. Vui lòng thử lại sau!');
                            return;
                        }
                    }

                });
            }
            setTimeout(() => {
                getCartInfo(response["message"]?.accessToken).then((response) => {
                    window.localStorage.setItem('cartInfo', JSON.stringify(response['message']));

                    let _cartInfo = response['message'];
                    if (_cartInfo !== null) {
                        window.localStorage.setItem('bixu', _cartInfo[0]?.owner?.bixu);
                    }
                });

                
            }, 1000);
        });

        // if (orderSuccess === false) {
        //     toast.error('Đặt hàng không thành công. Vui lòng thử lại!');
        //     setTimeout(function () {
        //         window.location.reload();
        //     }, 1000);
        // }

    } catch (e) {
        console.log(e);
    }
    useEffect(()=>{

        const time = new Date();
        const perc = JSON.parse(window.localStorage.getItem('layoutGA'));
        perc.ecommerce['transaction_id']= Math.floor(time.getTime() / 1000);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(perc);
        window.localStorage.removeItem("layoutGA");
        getCartItems(window.localStorage.getItem('key')).then((response) => {
            localStorage.setItem('itemsCart', JSON.stringify(response['message']));
        });
    },[])
  const call = setInterval(() => {
        if(orderInfo?.sale === ''){
            window.location.href="/";
            clearInterval(call);
        }
    }, 20000);

    return (<>
        <div className="bg-white" id="cart-css">
            <div className="row pdt-20 pdx-20">
                <span className="name-page">{msg}</span>
            </div>
            <div className="row mgt-10 pdx-10">
                <img src="/images/cart/Screen_Shot_2023-09-10_at_12.54_1.png" alt="icon" />
            </div>
            <div className="row mgt-10 text-center">
                <span className="text-normal-13">Mã đơn hàng: <strong>#<span className="text-bold-14">{orderInfo?.sale !== '' ? orderInfo?.sale : ''}</span></strong></span>
            </div>
            <div className="row">
                <div className="pdx-20">
                    <div className="row pdx-20 mgx-20 pdy-10 mgy-10 bg-yellow text-center">
                        <span className="text-normal-13">{msg}</span>
                    </div>
                </div>
            </div>
            {
                id !== '' ? (
                    <div className="row mgt-10">
                        <div className="pdx-30">
                            <button className="btn-cancel pdy-10" onClick={id !== '' ? (() => navigate('/mobile/orderdetail.html?' + id)) : (null)} >CHI TIẾT ĐƠN HÀNG</button>
                        </div>
                    </div>
                ) : (
                    null
                )
            }
            <div className="row mgt-10">
                <div className="pdx-30">
                    <button className="btn-confirm pdy-10" onClick={() => navigate('/')}>
                        TIẾP TỤC MUA HÀNG
                    </button>
                </div>
            </div>
        </div>
    </>
    )
}
export default ComplateOrderMobile;